import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "@/components/ui/sheet";
import { Logo } from "@/components/landing/Logo";
import { scrollToId } from "@/lib/scroll";
import { useContent } from "@/context/ContentContext";

const LINKS = [
  { id: "come-funziona", label: "Come funziona" },
  { id: "funzioni", label: "Funzioni AI" },
  { id: "risparmio", label: "Risparmio" },
  { id: "faq", label: "FAQ" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const { getText, ctaClick } = useContent();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const cta = getText("nav.cta", "Provalo gratis");

  return (
    <header id="top" data-testid="top-nav" className={`sticky top-0 z-50 w-full surface-navy transition-shadow duration-200 ${scrolled ? "shadow-lg shadow-black/20" : ""}`}>
      <div className="mx-auto flex h-[68px] max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo dark tagline />
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-link-${l.id}`} onClick={() => scrollToId(l.id)} className="text-sm font-medium text-slate-300 transition-colors duration-200 hover:text-white">
              {l.label}
            </button>
          ))}
        </nav>
        <div className="hidden items-center gap-4 md:flex">
          <Button data-testid="nav-primary-cta-button" onClick={ctaClick("nav.cta.link", "https://app.sedio.it")} className="btn-cta h-10 px-6">{cta}</Button>
        </div>
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" data-testid="nav-mobile-menu-button" aria-label="Apri menu" className="text-white hover:bg-white/10 hover:text-white"><Menu className="h-5 w-5" /></Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72">
              <div className="mt-6 flex flex-col gap-1">
                {LINKS.map((l) => (
                  <SheetClose asChild key={l.id}>
                    <button data-testid={`nav-mobile-link-${l.id}`} onClick={() => scrollToId(l.id)} className="rounded-lg px-3 py-3 text-left text-base font-medium text-foreground transition-colors duration-200 hover:bg-muted">{l.label}</button>
                  </SheetClose>
                ))}
                <SheetClose asChild>
                  <Button data-testid="nav-mobile-cta-button" onClick={ctaClick("nav.cta.link", "https://app.sedio.it")} className="btn-cta mt-4 h-11 w-full">{cta}</Button>
                </SheetClose>
                <div className="mt-3 flex gap-4 px-3 text-sm">
                  <a href="/privacy" className="text-muted-foreground hover:text-foreground">Privacy</a>
                  <a href="/termini" className="text-muted-foreground hover:text-foreground">Termini</a>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
